export default {
    fr: "French",
    en: "English",
}